<template>
<div class="detail">
    <p class="title">{{detail.name}}</p>
    <img :src="arr[active]" alt class="main-img" />
    <div class="swiper-box">
        <swiper :options="options">
            <swiper-slide v-for="(item, index) in arr" :key="index">
                <img :src="item" alt class="swiper-img" @click="active=index" />
            </swiper-slide>
        </swiper>
    </div>
    <div class="filter-box">
        <div class="filter">
            <div :class="{active:filter == 0}" @click="filter=0">产品介绍</div>
            <div :class="{active:filter ==1 }" @click="filter=1">部分产品型号及参数</div>
            <div :class="{active:filter == 2}" @click="filter=2">部分产品电性能测试曲线图</div>
        </div>
        <div class="wrap rich" v-html="html">

        </div>
    </div>
</div>
</template>

<script>
import {
    productview
} from "../../assets/js/api";
export default {
    data() {
        let _this = this;
        return {
            html: "",
            detail: {},
            arr: [],
            active: 0,
            filter: 0,
            options: {
                slidesPerView: 2,
                spaceBetween: 38,
            },
        };
    },
    watch: {
        filter(e) {
            if (e == 0) {
                this.html = this.detail.js;
            } else if (e == 1) {
                this.html = this.detail.xhcs;
            } else {
                this.html = this.detail.qxt;
            }
        },
        "$route.query.id": {
            handler(e) {
                location.reload();
            },
            deep: true,
        },
    },
    created() {
        productview({
            id: this.$route.query.id,
        }).then((r) => {
            this.arr = r.data.images ? r.data.images.split(",") : [];
            this.detail = r.data;
            this.html = r.data.js;
        });
    },
};
</script>

<style lang="less" scoped>
.title {
    text-align: center;
    font-size: 0.34rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #555555;
    margin-bottom: 0.36rem;
    padding: 0 .20rem;
    box-sizing: border-box;
}

.main-img {
    width: 100%;
    height: 4.56rem;
    object-fit: cover;
}

.swiper-box {
    padding: 0 0.47rem;
    box-sizing: border-box;
    margin-bottom: .74rem;
    img {
        width: 100%;
        height: 1.92rem;
    }
}

.filter-box {
    padding: 0 0.3rem;
    box-sizing: border-box;

    .wrap {
        padding: 0.55rem 0.32rem;
        box-sizing: border-box;
        background: white;
    }
}

.filter {
    display: flex;

    div:first-child {
        width: 25%;
    }

    div:last-child {
        width: 42%;
    }

    div {
        width: 33%;
        line-height: 0.72rem;
        text-align: center;
        font-size: 0.2rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #000000;
    }

    div.active {
        background: #ffffff;
        border-top: 0.04rem solid #126fcc;
        font-weight: 400;
    }
}
</style>
